import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { submitFilterDTO } from 'src/components/Common/UI/DndTable/types';


const convertToDataTable = (data: IGetPhonecentersSysModel[]): IGetPhonecentersSysModel[] => {
  const dataTableData: IGetPhonecentersSysModel[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllPhonecentersSysModelsList = async (): Promise<IGetPhonecentersSysModel[]> => {
  const response =  await axiosDefaultApi.get(`/api/PhonecentersSysModels/GetPhonecentersSysModels`);
  return convertToDataTable(response as unknown as IGetPhonecentersSysModel[]);
};

type QueryFnType = typeof getAllPhonecentersSysModelsList;

type UseGetAllPhonecentersSysModelsListOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllPhonecentersSysModelsList = ({ config }: UseGetAllPhonecentersSysModelsListOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllPhonecentersSysModelsList'],
    queryFn: () => getAllPhonecentersSysModelsList(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};